import React from 'react'
import { Calendar } from '../OutplacementBenefits/Calendar'
import { Stack } from '~/components/_layouts'
import { useMediaQueryScreen } from '~/hooks/useMediaQuery'
import { useBenefits } from '../BenefitsProvider'
import { Card, Typography } from '~/components/_atoms/index'
import { useTranslation } from '~/hooks/useTranslation'

const SelectUpcomingMeetings = ({ className }) => {
  const { serviceRequestList, current_user } = useBenefits()

  const { t } = useTranslation('upcoming_meetings')

  const getCalendarEvents = () => {
    const events = []
    const requestTypes = Object.keys(serviceRequestList).filter(
      (key) =>
        serviceRequestList[key].calendly_event &&
        serviceRequestList[key].calendly_event.start_time,
    )
    requestTypes.forEach((requestTypes) => {
      const event = serviceRequestList[requestTypes].calendly_event
      if (event && event.start_time) {
        events.push(event)
      }
    })
    return events
  }

  const calendarEvents = getCalendarEvents()
  const isLargeScreen = useMediaQueryScreen('lg')

  return (
    <Stack spacing={3} className={`${className}`}>
      <div className="mt-4">
        {isLargeScreen && (
          <Card color="select-light" className="border-cod-gray-300">
            <Typography variant="subtitle" className="mb-2 text-select-blue">
              {t('title')}
            </Typography>
            <Typography className="mb-5">{t('description')}</Typography>
            <div className="relative">
              <Calendar
                calendar_events={calendarEvents}
                homePageDisplay={true}
                coachServices={true}
                opRedesign={true}
                coachDashboardDisplay={false}
                isSelectCoachServicesPage={true}
                locale={current_user.locale}
              />
            </div>
          </Card>
        )}
      </div>
    </Stack>
  )
}

export default SelectUpcomingMeetings
